<template>
  <div>
    <v-dialog v-model="dialog" persistent max-width="650px">
      <v-card>
        <v-card-title class="red-darken-2 text-white">
          <v-row>
            <span class="headline">
              {{ $t("leko_employees.approve_parts.automatic_approval.label") }}
            </span>
            <v-spacer />
            <v-btn variant="outlined" icon color="white" @click="close">
              <v-icon> mdi-close </v-icon>
            </v-btn>
          </v-row>
        </v-card-title>
        <v-card-text>
          <v-row column wrap align-center justify-center>
            <v-col>
              <v-alert :value="true" type="info">
                {{
                  $t("leko_employees.approve_parts.automatic_approval.alert")
                }}
              </v-alert>
            </v-col>

            <v-col>
              <v-select
                v-model="institution"
                :items="institutions"
                item-title="title"
                item_value="_id"
                :label="
                  $t(
                    'leko_employees.approve_parts.automatic_approval.institution',
                  )
                "
                color="red-darken-1"
                return-object
              />
            </v-col>
            <v-col>
              <div v-if="logs.length > 0">Logs</div>
              <v-list two line>
                <template v-for="(log, index) in logs" :key="index">
                  <v-list-tile>
                    <v-list-tile-content> {{ log }} </v-list-tile-content>
                    <v-btn icon @click="downloadLog(log)">
                      <v-icon color="grey-darken-2"> download </v-icon>
                    </v-btn>
                    <v-btn icon @click="deleteLog(log)">
                      <v-icon color="grey-darken-2"> close </v-icon>
                    </v-btn>
                  </v-list-tile>
                  <v-divider v-if="log" :key="`d${index}`" />
                </template>
              </v-list>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            variant="outlined"
            color="success"
            :loading="loading"
            :disabled="!institution"
            @click="approve"
          >
            {{ $t("leko_employees.approve_parts.automatic_approval.approve") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogDelete" width="auto">
      <v-card>
        <v-card-title class="text-h6">
          <v-alert class="mb-0" :value="true" type="error">
            {{ $t("delete_alert") }}
          </v-alert>
        </v-card-title>

        <v-card-actions>
          <v-spacer />
          <v-btn text @click="dialogDelete = false">
            {{ $t("close") }}
          </v-btn>
          <v-btn color="red" variant="outlined" @click="confirmDelete()">
            {{ $t("delete") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import getRequest from "../../api/getRequest";
import putRequest from "../../api/putRequest";
import deleteRequest from "../../api/deleteRequest";

export default {
  data: () => ({
    dialog: false,
    loading: false,
    institution: null,
    logs: [],
    institutions: [],
    dialogDelete: false,
    logToDelete: null,
  }),
  computed: {},
  watch: {},
  methods: {
    open() {
      this.dialog = true;
      this.getInstitutions();
      this.getLogs();
    },
    close() {
      this.dialog = false;
      this.institutions = [];
      this.institution = null;
      this.$emit("close");
    },
    approve() {
      this.loading = true;
      putRequest(
        "/temporary-part/automatic-approval",
        `user_id=${this.$store.getters.userId}&institution_id=${this.institution._id}`,
        {},
      )
        .then(() => {
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        })
        .finally(() => {
          this.loading = false;
          this.close();
        });
    },
    getInstitutions() {
      getRequest("/institution")
        .then((response) => {
          this.institutions = response.institutions;
        })
        .catch(() => {});
    },
    getLogs() {
      getRequest("/temporary-part/approve/logs")
        .then((response) => {
          this.logs = response.files;
        })
        .catch(() => {});
    },
    downloadLog(log) {
      getRequest("/temporary-part/approve/logs", `log=${log}`)
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", log);
          document.body.appendChild(link);
          link.click();
        })
        .catch(() => {});
    },
    deleteLog(log) {
      this.logToDelete = log;
      this.dialogDelete = true;
    },
    confirmDelete() {
      this.loading = true;
      deleteRequest("/temporary-part/approve/logs", `log=${this.logToDelete}`)
        .then(() => {})
        .catch(() => {})
        .finally(() => {
          this.dialogDelete = false;
          this.logToDelete = null;
          this.getLogs();
        });
    },
  },
};
</script>
